import { Platform } from "../constants";

import { SetupSection } from "./components/setup-section";
import { OrderedList } from "./components/styled";
import { URLVerification, UtmParamsClipboard } from "./components/utms";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.OUTBRAIN;

export const OutbrainDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl: "https://www.outbrain.com/help/advertisers/utm-tracking/",
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

export const OutbrainSetup = () => (
  <>
    <SetupSection title="Copy these UTM parameters to all existing campaigns in Outbrain">
      <div className="flex flex-col gap-4">
        <OrderedList variant="upper-alpha" className="m-0">
          <>Navigate to each campaign’s settings page</>
          <>Go to the ‘Track’ section</>
          <>Paste UTM parameters</>
        </OrderedList>
        <UtmParamsClipboard platform={PLATFORM} />
      </div>
    </SetupSection>
    <URLVerification platform={PLATFORM} />
  </>
);
